import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API_ENDPOINT } from './endpoints';
import { tStatementAddedResponse
    , tStatementHistoryResponse
} from 'app/types/statement.type';
import { SearchEngineModel } from 'app/models/shared/search-engine.model';
import { StatementDetailModel, StatementOCRUpdateModel, StatementVendorModel } from 'app/models/statements/statement-vendor.model';
import { ResponseModel, SearchResponseModel } from 'app/models/shared';
import { ErpType } from 'app/shared/enums';
import { Observable } from 'rxjs';
import { StatementApItemStatusModel, StatementStatusModel } from '../modules/statement/model/statement-status.model';

@Injectable()
export class StatementService {
    constructor(private apiService: ApiService) {

    }

      
  statementAdd(file: File, erp_type?: ErpType, vendor_id?: string, organization_id?: string) {
    const formData = new FormData();
      formData.append('file', file);
      if (erp_type) formData.append('erp_type', erp_type);
      if (organization_id) formData.append('organization_id', organization_id);
      if (vendor_id) formData.append('vendor_id', vendor_id);

    return this.apiService.postFormData<tStatementAddedResponse>(`${API_ENDPOINT.Statement}/upload`, formData);
  };

  validateUsage() {
    // skipcq: JS-0323
    return this.apiService.get<any>(`${API_ENDPOINT.Statement}/validate-usage`);
  };

  searchStatementVendors(searchRequest: SearchEngineModel) {
    return this.apiService.post<SearchResponseModel<StatementVendorModel>>(
      `${API_ENDPOINT.Statement}/vendor`,
      searchRequest
    );
  };
  
  archiveStatement(id: string) {
    return this.apiService.update(`${API_ENDPOINT.Statement}/archive/${id}`);
  };
  
  restoreStatement(id: string) {
    return this.apiService.update(`${API_ENDPOINT.Statement}/restore/${id}`);
  };
  
  deleteStatement(id: string) {
    return this.apiService.delete(`${API_ENDPOINT.Statement}/${id}`);
  };
  
  getStatementDetail(id: string) {
    return this.apiService.get<StatementDetailModel>(`${API_ENDPOINT.Statement}/vendor/${id}`);
  };
  
  getStatementStatus(id: string): Observable<ResponseModel<StatementStatusModel>> {
    // skipcq: JS-0323
    return this.apiService.get<StatementStatusModel>(`${API_ENDPOINT.Statement}/vendor/${id}/extraction-status`);
  };
  
  getApStatementItemsStatus(id: string): Observable<ResponseModel<StatementApItemStatusModel>> {
    // skipcq: JS-0323
    return this.apiService.get<StatementApItemStatusModel>(`${API_ENDPOINT.Statement}/vendor/${id}/ap-items-status`);
  };
  
  getStatementFile(id: string) {
    // skipcq: JS-0323
    return this.apiService.get<any>(`${API_ENDPOINT.Statement}/preview/${id}`);
  };
  
  updateStatementDetail(id: string, body: StatementOCRUpdateModel) {
    return this.apiService.update(`${API_ENDPOINT.Statement}/${id}`, body);
  };
  
  finalizeStatement(id: string) {
    return this.apiService.update(`${API_ENDPOINT.Statement}/finalize/${id}`);
  };
  
  getStatementHistory(id: string) {
    return this.apiService.get<tStatementHistoryResponse[]>(`${API_ENDPOINT.Statement}/history/${id}`);
  };

  getStatementPages(id: string) {
    return this.apiService.get<{ generated: boolean; pages: { page: number; url: string }[] }>(`${API_ENDPOINT.Statement}/pages/${id}`);
  };

      
  resolveImport(files: File[], statement_id: string, subject: string, note: string) {
    const formData = new FormData();
      files.forEach(file => {
        formData.append('files', file);
      });
      formData.append('subject', subject);
      formData.append('note', note);

    return this.apiService.postFormData<tStatementAddedResponse>(`${API_ENDPOINT.Statement}/${statement_id}/resolve-import-error`, formData);
  };

  assignVendorToInboundEmail(inboundEmailId: string, vendorId: string, statementId?: string) {
    // skipcq: JS-0323
    const body: Record<string, string> = { vendor_id: vendorId };
    if (statementId) {
      body['statement_id'] = statementId;
    }
    return this.apiService.patch<any>(`${API_ENDPOINT.Email}/inbound/${inboundEmailId}/assign-vendor`, body);
  };

  getInboundEmailById(id: string) {
    // skipcq: JS-0323
    return this.apiService.get<any>(`${API_ENDPOINT.Email}/inbound/${id}`);
  };

  updateStatementDates(id: string, opening_date: string, closing_date: string) {
    return this.apiService.patch<{ opening_date: string; closing_date: string }>(
      `${API_ENDPOINT.Statement}/${id}/dates`,
      { opening_date, closing_date }
    );
  };

  assignVendor(statementId: string, vendorId: string) {
    // skipcq: JS-0323
    return this.apiService.post<any>(
      `${API_ENDPOINT.Statement}/${statementId}/assign-vendor`,
      { vendor_id: vendorId }
    );
  };
}
